import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { Icon, Button, Loader } from 'Components';
import AppContext from 'src/AppContext';
import NavDesktopLogo from './NavDesktopLogo/NavDesktopLogo';
import NavDesktopFooter from './NavDesktopFooter/NavDesktopFooter';
import NavDesktopClients from './NavDesktopClients/NavDesktopClients';
import NavDesktopFilter from './NavDesktopFilter/NavDesktopFilter';
import NavDesktopPinnedItems from './NavDesktopItemsPinned/NavDesktopItemsPinned';
import NavDesktopItemsAll from './NavDesktopItemsAll/NavDesktopItemsAll';
import './NavDesktop.css';

const NavDesktop = props => (
  <div
    className={classNames(
      'nav__desktop',
      {
        'nav__desktop--collapsed': props.isNavCollapsed,
        'nav__desktop--not-collapsed': !props.isNavCollapsed,
      },
    )}
  >
    <div className="nav__desktop__collapser">
      <Button onClick={() => props.setAppState({ isNavCollapsed: !props.isNavCollapsed })}>
        <Icon icon={props.isNavCollapsed ? 'keyboard_arrow_right' : 'keyboard_arrow_left'} />
      </Button>
    </div>
    { props.isNavCollapsed ? (
      <Fragment>
        <Link className="nav__desktop__home-button" to="/" >
          <Icon icon="home" />
        </Link>
        <footer>
          <div className="nav-desktop__info">
            <Button
              onClick={() => props.setAppState({ isTutorialShowing: !props.isTutorialShowing })}
            >
              <Icon icon="info" />
            </Button>
          </div>
        </footer>
      </Fragment>
  ) : (
    <Fragment>
      <NavDesktopLogo />
      { props.hasAcceptedTerms &&
        <Fragment>
          { props.isInternalUser &&
            <NavDesktopClients
              {...props.clients}
              userInfo={props.userInfo}
              setAppState={props.setAppState}
              clientNumber={props.clientNumber}
            /> }
          { !(props.isInternalUser && props.clientNumber === '') ?
            <Fragment>
              <NavDesktopFilter
                {...props.filterFields}
                filterFieldValue={props.filterFieldValue}
                filterFieldLabel={(props.filterFields.options
                  .find(x => x.value === props.filterFieldValue) || {}).label
                }
                filterItemValue={props.filterItemValue}
              />
              <div className="nav__desktop__items">
                { (props.filterPinnedItems.options.length > 0 &&
                  !props.filterItems.isLoading &&
                  !props.filterPinnedItems.isLoading) &&
                  <NavDesktopPinnedItems
                    options={props.filterPinnedItems.options}
                    filterItemValue={props.filterItemValue}
                    togglePin={props.togglePin}
                    isTutorialShowing={props.isTutorialShowing}
                  /> }
                { (!props.filterItems.isLoading && !props.filterPinnedItems.isLoading) &&
                  <NavDesktopItemsAll
                    options={props.filterItems.options}
                    filterValue={props.filterFields.value}
                    filterItemValue={props.filterItemValue}
                    togglePin={props.togglePin}
                    viewMore={props.ViewMore}
                    onViewMore={() => props.setNavState(prevState => ({
                      ViewMore: !prevState.ViewMore,
                    }))}
                  />
                }
                { (props.filterItems.isLoading || props.filterPinnedItems.isLoading) &&
                  <Loader dots={8} />
                }
              </div>
            </Fragment>
            :
            <div className="nav__desktop__items" />
          }
        </Fragment>
      }
      <footer>
        <NavDesktopFooter {...props} />
      </footer>
    </Fragment>)
  }
  </div>
);

NavDesktop.propTypes = {
  filterFields: PropTypes.shape({
    isLoading: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })),
    value: PropTypes.string,
  }),
  filterFieldValue: PropTypes.string,
  filterItems: PropTypes.shape({
    abortController: PropTypes.shape({}),
    isLoading: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string,
      isPinned: PropTypes.bool,
    })),
  }),
  filterPinnedItems: PropTypes.shape({
    isLoading: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string,
      isPinned: PropTypes.bool,
    })),
  }),
  filterItemValue: PropTypes.string,
  isNavCollapsed: PropTypes.bool,
  isInternalUser: PropTypes.bool,
  internalClientOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })),
  userInfo: PropTypes.shape({}),
  viewMore: PropTypes.bool,
  internalClientsIndex: PropTypes.number,
  togglePin: PropTypes.func,
  setAppState: PropTypes.func,
  setNavState: PropTypes.func,
  clientNumber: PropTypes.string,
  clients: PropTypes.shape({ data: PropTypes.arrayOf(PropTypes.shape({})) }),
  isTutorialShowing: PropTypes.bool,
  ViewMore: PropTypes.bool,
  hasAcceptedTerms: PropTypes.bool,
};

export default props => (
  <AppContext.Consumer>
    {context => (
      <NavDesktop
        {...props}
        setAppState={context.setAppState}
        isInternalUser={context.isInternalUser}
      />
    )}
  </AppContext.Consumer>
);



// WEBPACK FOOTER //
// ./src/containers/Nav/NavDesktop/NavDesktop.jsx